import { styled } from "@mui/system";
import React, { useEffect, useState } from "react";

interface Props {
  sx?: any; //TODO Figure out what SxProps is accepted when using styled from @mui/system
  dark?: boolean;
}

const IMG = styled("img")({
  maxWidth: "100%",
});

const BNLogo: React.FC<Props> = ({ sx, dark }) => {
  const [isPrint, setIsPrint] = useState(false);

  useEffect(() => {
    window.onbeforeprint = function () {
      setIsPrint(true);
    };
    window.onafterprint = function () {
      setIsPrint(false);
    };
  }, []);

  const logo = {
    src: `https://res.cloudinary.com/banknorwegian/image/upload/statics/logo.svg`,
    srcDark: "https://res.cloudinary.com/banknorwegian/image/upload/statics/logo_dark.svg",
    srcPrint: `https://res.cloudinary.com/banknorwegian/image/upload/e_colorize,co_rgb:000000/statics/logo.png`,
    altText: "Logo Bank Norwegian Branch of NOBA Bank Group",
    width: 200,
    height: 40,
  };

  // Inline SVG gives issues in Safari, so using img tag instead
  // Don't use Box for img tag as it translates width and height to styles and browser loose the aspect ratio to avoid CLS
  return (
    <IMG
      width={logo.width}
      height={logo.height}
      alt={logo.altText}
      src={isPrint ? logo.srcPrint : dark ? logo.srcDark : logo.src}
      sx={sx}
      className="no-color-invert"
    />
  );
};

export default BNLogo;
